'use strict';

/**
 * PageController
 *
 * @author Mathias Hayoz <mathias.hayoz@namics.com>
 */
T.Module.PageController = T.createModule({

	_selectors: {
		table: 'table'
	},

	_eventNames: {
		responsiveTable: 'pageController.responsiveTables',
		loadYoutubeApi: 'pageController.loadYoutubeApi'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		// Register Events
		this._events.on('t.sync', this.sync.bind(this));

		// For Debugging: Expose Viewport Changers to console
		// this._events.on('viewport.setup', this._onViewportSetup.bind(this));
		// this._events.on('viewport.match', this._onViewportMatch.bind(this));
		// this._events.on('viewport.unmatch', this._onViewportUnmatch.bind(this));

		this.youtubeApiCallbackStack = [];
		this.youtubeApiLoading = false;

		this._events.on(this._eventNames.responsiveTable, this.initializeResponsiveTables.bind(this));
		this._events.on(this._eventNames.loadYoutubeApi, this.onLoadYoutubeApi.bind(this));

		resolve();
	},
	sync: function sync() {
		// Tc Config
		var config = this._sandbox.getConfig();

		// Register Media Queries
		this.registerMediaQueries(config.mediaQueries);

		this.checkForResponsiveTables();
	},


	/**
  * Makes tables scrollable on mobile viewports.
  *
  * @returns {undefined}
  */
	checkForResponsiveTables: function checkForResponsiveTables() {
		var $tables = $(this._selectors.table, this.$ctx);
		this.initializeResponsiveTables($tables);
	},


	/**
  * Initialize responsive table behaviour for mobile viewports.
  *
  * @param {Object} $tables The tables to initialize the responsive behaviour
  * @returns {void}
  */
	initializeResponsiveTables: function initializeResponsiveTables($tables) {

		if ($tables.length > 0) {
			$tables.indicate({
				iconLeft: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 12"><defs><style>.cls-1{fill:#00aae1;}</style></defs><title>RUAG_Icon</title><path class="cls-1" d="M17.65,5.65H1.24L5.68.58A.35.35,0,0,0,5.15.12L0,6l5.15,5.88a.35.35,0,0,0,.53-.46L1.23,6.34H17.65a.35.35,0,1,0,0-.69Z"/></svg>',
				iconRight: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 12"><defs><style>.cls-1{fill:#00aae1;}</style></defs><title>RUAG_Icon</title><path class="cls-1" transform="rotate(-179.98269653320312 9.002978324890137,6) " d="M17.65,5.65H1.24L5.68.58A.35.35,0,0,0,5.15.12L0,6l5.15,5.88a.35.35,0,0,0,.53-.46L1.23,6.34H17.65a.35.35,0,1,0,0-.69Z"/></svg>'
			});
		}
	},
	loadYoutubeApi: function loadYoutubeApi(callbackFn) {
		if (typeof YT === 'undefined') {
			this.youtubeApiCallbackStack.push(callbackFn);
			this.requestYoutubeAPi();
		} else {
			callbackFn();
		}
	},


	/**
  * Registers multiple media queries.
  * @see registerMediaQuery
  * @param {Object} mediaQueries Object of mediaqueries, e.g. { 'small': '(max-width: 320px)', 'medium-up': … }
  * @returns {undefined}
  */
	registerMediaQueries: function registerMediaQueries(mediaQueries) {
		var _this = this;

		Object.keys(mediaQueries).forEach(function (key) {
			var element = mediaQueries[key];
			_this.registerMediaQuery(key, element);
		});
	},


	/**
  * Registers (single) media query in enquire.js.
  * enquire.js triggers events when viewports are changing.
  * @param {string} name Media query name, e.g. 'small'
  * @param {string} query query string, e.g. '(max-width: 320px)'
  * @returns {undefined}
  */
	registerMediaQuery: function registerMediaQuery(name, query) {
		var _this2 = this;

		if (window.enquire) {
			window.enquire.register(query, {
				'setup': function setup() {
					_this2._events.emit('viewport.setup', name);
				},
				'match': function match() {
					_this2._events.emit('viewport.match', name);
				},
				'unmatch': function unmatch() {
					_this2._events.emit('viewport.unmatch', name);
				},
				'deferSetup': true
			},
			// shouldDegrade = true (see: http://wicky.nillia.ms/enquire.js/#delving-deeper));
			true);
		}
	},


	/**
  * Request the youtube js api if it is not already loading
  *
  * @returns {void}
  */
	requestYoutubeAPi: function requestYoutubeAPi() {
		if (!this.youtubeApiLoading) {
			window.onYouTubeIframeAPIReady = this.youtubeApiLoaded.bind(this);
			this.youtubeApiLoading = false;

			$.fn.loadScript('//www.youtube.com/iframe_api', null);
		}
	},


	/**
  * Callback when the youtube api finished with loading
  *
  * @returns {void}
  */
	youtubeApiLoaded: function youtubeApiLoaded() {
		$.each(this.youtubeApiCallbackStack, function (index, callbackFn) {
			if (typeof callbackFn === 'function') {
				callbackFn();
			}
		});

		this.youtubeApiLoading = false;
	},


	/**
  * Event when the youtube api should be loaded
  *
  * @param {Function} eventData the event data
  * @returns {void}
  */
	onLoadYoutubeApi: function onLoadYoutubeApi(eventData) {
		this.loadYoutubeApi(eventData.callbackFn);
	},
	_onViewportSetup: function _onViewportSetup(wpName) {
		window.console.log('setup ' + wpName);
	},
	_onViewportMatch: function _onViewportMatch(wpName) {
		window.console.log('match ' + wpName);
	},
	_onViewportUnmatch: function _onViewportUnmatch(wpName) {
		window.console.log('unmatch ' + wpName);
	}
});